export const PackageValidationSchema = (json) => {
    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

        // Helper function to safely handle string operations
        const safeStringTrim = (value) => {
            if (value === null || value === undefined) return '';
            return typeof value === 'string' ? value.trim() : String(value).trim();
        };

        // Package name validation
        if (!json?.name || safeStringTrim(json.name) === "") {
            Object.assign(errorJson, { name: "Package name cannot be empty *" });
        }

        // Description validation
        if (!json?.description || safeStringTrim(json.description) === "") {
            Object.assign(errorJson, { description: "Package description cannot be empty *" });
        }

        // Services validation - must have at least one service
        // if (!json?.services || !Array.isArray(json.services) || json.services.length === 0) {
        //     Object.assign(errorJson, { services: "At least one service must be selected *" });
        // }

        // Total actual price validation
        if (json?.totalActualPrice === undefined || json?.totalActualPrice === null || json?.totalActualPrice === "") {
            Object.assign(errorJson, { totalActualPrice: "Total actual price cannot be empty *" });
        } else if (isNaN(json.totalActualPrice) || parseFloat(json.totalActualPrice) < 0) {
            Object.assign(errorJson, { totalActualPrice: "Total actual price must be a valid positive number *" });
        }

        // Package price validation
        if (json?.packagePrice === undefined || json?.packagePrice === null || json?.packagePrice === "") {
            Object.assign(errorJson, { packagePrice: "Package price cannot be empty *" });
        } else if (isNaN(json.packagePrice) || parseFloat(json.packagePrice) < 0) {
            Object.assign(errorJson, { packagePrice: "Package price must be a valid positive number *" });
        } else if (parseFloat(json.packagePrice) > parseFloat(json.totalActualPrice)) {
            Object.assign(errorJson, { packagePrice: "Package price cannot be greater than total actual price *" });
        }

        // Discount amount validation (optional, but if present must be valid)
        if (json?.discountAmount !== undefined && json.discountAmount !== null && json.discountAmount !== "") {
            if (isNaN(json.discountAmount) || parseFloat(json.discountAmount) < 0) {
                Object.assign(errorJson, { discountAmount: "Discount amount must be a valid positive number *" });
            }
        }

        // Discount percentage validation (optional, but if present must be valid)
        if (json?.discountPercentage !== undefined && json.discountPercentage !== null && json.discountPercentage !== "") {
            if (isNaN(json.discountPercentage) || parseFloat(json.discountPercentage) < 0) {
                Object.assign(errorJson, { discountPercentage: "Discount percentage must be a valid positive number *" });
            } else if (parseFloat(json.discountPercentage) > 100) {
                Object.assign(errorJson, { discountPercentage: "Discount percentage cannot be more than 100 *" });
            }
        }

        // Validity validation
        if (json?.validity) {
            if (!json.validity.value || json.validity.value === "") {
                Object.assign(errorJson, { validityValue: "Validity value cannot be empty *" });
            } else if (isNaN(json.validity.value) || parseInt(json.validity.value) <= 0) {
                Object.assign(errorJson, { validityValue: "Validity value must be a positive number *" });
            }

            if (!json.validity.unit || safeStringTrim(json.validity.unit) === "") {
                Object.assign(errorJson, { validityUnit: "Validity unit cannot be empty *" });
            }
        }

        // Unit IDs validation - must have at least one unit
        // if (!json?.unitIds || !Array.isArray(json.unitIds) || json.unitIds.length === 0) {
        //     Object.assign(errorJson, { unitIds: "At least one unit must be selected *" });
        // }

        resolve(errorJson);
    });

    return MyPromise;
};
